import { FC } from "react";

import { EditorElement } from "@smart/itops-serialisation-basic";

import { LinkPopup } from "./link";
import { EditorModal, ModalOption } from "../hooks";

const popups: Record<ModalOption, FC<{ element?: EditorElement }>> = {
  link: LinkPopup,
};

export const Popup = ({ option, element }: EditorModal) => {
  const PopupComponent = popups[option];

  return <PopupComponent element={element} />;
};
